/* KOKUA C11 — keeps the reservation notice and button label in step with the selected variant.
   Dawn re-renders the product section on variant change and resets the button to "Add to cart";
   this listens to Dawn's own variantChange event and copies our block from the fetched HTML.
   No stock Dawn JavaScript is modified. */
(function () {
  if (window.kokuaReserveInit) return;
  window.kokuaReserveInit = true;

  function onVariantChange(event) {
    var data = event && event.data;
    if (!data || !data.html) return;
    var source = data.html.querySelector('[data-reserve-notice]');
    var isReserve = !!source && !source.hasAttribute('hidden');

    document.querySelectorAll('product-info').forEach(function (info) {
      var id = info.dataset.originalSection || info.dataset.section;
      if (id !== data.sectionId) return;

      var destination = info.querySelector('[data-reserve-notice]');
      if (destination && source) destination.replaceWith(source.cloneNode(true));

      var button = info.querySelector('.product-form__submit');
      var label = button && button.querySelector('span');
      if (isReserve && label && !button.hasAttribute('disabled')) {
        label.textContent = source.dataset.buttonLabel;
      }
    });
  }

  function init() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
